import { render } from "./OcrApiErrorPanel.vue?vue&type=template&id=724c0a08"
import script from "./OcrApiErrorPanel.vue?vue&type=script&lang=js"
export * from "./OcrApiErrorPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__